/* eslint-disable @next/next/no-img-element */
import PropTypes from "prop-types";
import { carouselImageFormatter, magnify } from "../helper";
import Styles from "./index.module.scss";
import { MdOutlineZoomInMap } from "react-icons/md";
import { useState } from "react";
import { CollapseIcon } from "@/components/svgs";

export default function ImageZoomModal({
  showImageZoom,
  activeIndex,
  carouselItem = [],
  defaultImageLink,
  isNewProduct,
}) {
  const [zoomActive, setZoomActive] = useState(true);
  const activeItem =
    Array.isArray(carouselItem) && carouselItem.length > 0
      ? carouselItem[activeIndex] || carouselItem[0]
      : null;

  const imageResource =
    typeof activeItem === "string" ? { src: activeItem } : activeItem || "";

  const zoomSrc = imageResource || defaultImageLink;

  const handleMagnifier = (e, myImageId) => {
    let glass = document.getElementsByClassName("img-magnifier-glass");
    !zoomActive
      ? magnify(myImageId, 3)
      : glass && glass.length > 0 && zoomActive
        ? glass[0].parentNode.removeChild(glass[0])
        : false;
  };

  return (
    <div className={Styles.productExpandContainer}>
      <div className="product-expand-container">
        <div className="product-expand-inner">
          <div className="magnify">
            <div className="magnify-lens"></div>
            <div
              className="img-magnifier-container max-h-[725px]"
              onMouseEnter={e => {
                setZoomActive(true);
                handleMagnifier(e, "myImage");
              }}
              onMouseLeave={e => {
                setZoomActive(false);
                handleMagnifier(e, "myImage");
              }}
            >
              <img
                src={zoomSrc?.src}
                alt={"zoom-modal"}
                className="h-[500px] w-auto"
                onError={e =>
                  (e.target.src = zoomSrc?.fallBackSrc || defaultImageLink)
                }
                id="myImage"
              />
            </div>
          </div>
        </div>
        <div className="product-slide-expand cursor-pointer">
          <button
            className="cursor-pointer product-slide-expand--close bg-transparent"
            onClick={() => showImageZoom(false)}
          >
            <CollapseIcon color="#666" className="cursor-pointer" />
          </button>
        </div>
      </div>
    </div>
  );
}

ImageZoomModal.propTypes = {
  showImageZoom: PropTypes.func,
  activeIndex: PropTypes.number,
  carouselItem: PropTypes.array,
  defaultImageLink: PropTypes.string,
  isNewProduct: PropTypes.bool,
};
